import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fichamonitoria',
  templateUrl: './fichamonitoria.component.html',
  styleUrls: ['./fichamonitoria.component.css']
})
export class FichamonitoriaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
